import { isFunction } from 'ramda-adjunct';
import { useCallback, useRef, useState } from 'react';

// taken from https://usehooks.com/useintersectionobserver/

type IntersectionObserverOptions = {
  threshold?: number;
  root?: Document | Element;
  rootMargin?: string;
};

const isIntersectionObserverSupported = isFunction(window.IntersectionObserver);

export function useIntersectionObserver(options: IntersectionObserverOptions = {}) {
  const { threshold = 0, root = null, rootMargin = '0px' } = options;
  const [entry, setEntry] = useState(null);

  const previousObserver = useRef(null);

  const customRef = useCallback(
    (node) => {
      if (!isIntersectionObserverSupported) {
        return;
      }

      if (previousObserver.current) {
        previousObserver.current.disconnect();
        previousObserver.current = null;
      }

      if (node?.nodeType === Node.ELEMENT_NODE) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            setEntry(entry);
          },
          { threshold, root, rootMargin },
        );

        observer.observe(node);
        previousObserver.current = observer;
      }
    },
    [threshold, root, rootMargin],
  );

  return [customRef, entry];
}
